import { render } from "./TheTerm.vue?vue&type=template&id=72ba58b2&scoped=true"
const script = {}

import "./TheTerm.vue?vue&type=style&index=0&id=72ba58b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ba58b2"]])

export default __exports__